
//when the sticky anchor gets to the top of the page then change the postion to fixed.

function stickyAnchorLinkAreaFixToNav() { 

    const stickyAnchorLinkArea = document.querySelector('.wp-block-acf-sticky-anchor-link-area');
    if (!stickyAnchorLinkArea) return;
    
    const stickyAnchorLinkAreaFirstPosition = stickyAnchorLinkArea.getBoundingClientRect().top + window.pageYOffset;
    const parentElementHeight = stickyAnchorLinkArea.parentElement.offsetHeight;

    const scrollHandler = () => {

        const stickyAnchorLinkAreaOffsetTopUpdate = stickyAnchorLinkArea.getBoundingClientRect().top + window.pageYOffset;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        //correct position also includse comparing to the first position of the element. If this is greater then revert to sticky.
        if (scrollTop === stickyAnchorLinkAreaOffsetTopUpdate && scrollTop >= stickyAnchorLinkAreaFirstPosition) {
            stickyAnchorLinkArea.classList.add('js-sticky-anchor-link-area-fixed');
        } else {
            stickyAnchorLinkArea.classList.remove('js-sticky-anchor-link-area-fixed');
        }
    }

    window.addEventListener('scroll', throttle(scrollHandler, 5));

    //on page load if the element is already scrolled past then make it fixed.
    if (window.pageYOffset >= stickyAnchorLinkAreaFirstPosition) {
        stickyAnchorLinkArea.classList.add('js-sticky-anchor-link-area-fixed');
        stickyAnchorLinkArea.style.opacity = '0'; //<-- hide the sticky anchor link area on page load if its position is fixed behind the navbar. It will become visible when the user scrolls up and the navbar becomes hidden.
    }

}
    

// function interactWithFixedHeaderNavbar() { 

//     const stickyAnchorLinkArea = document.querySelector('.wp-block-acf-sticky-anchor-link-area');
//     const navBars = document.querySelectorAll('.js-on-scroll-hide-nav');

//     if (!stickyAnchorLinkArea || !navBars.length) return;

//     const scrollHandler = () => {

//         for (const navBar of navBars) {

//             if (navBar.classList.contains('nav-visible') && stickyAnchorLinkArea.classList.contains('js-sticky-anchor-link-area-fixed')) {
//                 stickyAnchorLinkArea.style.opacity = '0';
                
//             } else {
//                 stickyAnchorLinkArea.style.opacity = '1';
//             }
//         }
//     }

//     window.addEventListener('scroll', throttle(scrollHandler, 5));
// }

// draws a horziontal progress bar at the top on the stick element to show  how far down the page the user has scrolled.
function scrollPageDepthHorizontalIndicator() { 

    const allProgressBars = document.querySelectorAll('.js-scroll-progress-bar span');
    if (!allProgressBars.length) return; // Exit if the progress bar elements are not found

    const scrollHandler = () => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const scrollPercent = (scrollTop / docHeight) * 100;

        for(const progressBar of allProgressBars) {
            progressBar.style.width = `${scrollPercent}%`;
        }
    };


    window.addEventListener('scroll', throttle(scrollHandler, 10), { passive: true });
}

//if an anchor link href matches an element ID on the page then add an active class to anchor link 
function observeCurrentSectionAddActiveClassToAnchorLink() { 

    const allAnchorLinks = document.querySelectorAll('.wp-block-acf-sticky-anchor-link-area__link')
    const allSectionsWithIds = document.querySelectorAll('.wp-block-group[id]'); //<--only look for wp-block-group elements with IDs as these are the only ones that can be linked to by anchor links.

    if (!allAnchorLinks.length) return; // Exit if no anchor links are found
    
    const sectionObserverOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5 // Adjust this value as needed
    };  

    const sectionObserver = new IntersectionObserver((entries) => {

        entries.forEach(entry => {

            const sectionId = entry.target.id;

            if (entry.isIntersecting) {

                for (const anchorLink of allAnchorLinks) {

                    const anchorLinkHref = anchorLink.getAttribute('href');

                    anchorLink.classList.remove('active');

                    if (anchorLinkHref === `#${sectionId}`) {
                        anchorLink.classList.add('active');
                    }
                }   
            }
            
        });

    }, sectionObserverOptions);

    allSectionsWithIds.forEach(section => {
        sectionObserver.observe(section);
    });
    
}

function observeFixedHeaderNavbar() { 

    // Select the node that will be observed for mutations
    const navBars = document.querySelectorAll(".js-on-scroll-hide-nav");
    const stickyAnchorLinkArea = document.querySelector('.wp-block-acf-sticky-anchor-link-area');

    if (!navBars.length || !stickyAnchorLinkArea) return;

    // Options for the observer (which mutations to observe)
    const config = { attributes: true, childList: false, subtree: false };

    const callback = (mutationList) => {

        for (const mutation of mutationList) {

            if (mutation.target.classList.contains('nav-visible') && stickyAnchorLinkArea.classList.contains('js-sticky-anchor-link-area-fixed')) {
        
                stickyAnchorLinkArea.style.opacity = '0';

            } else {
                stickyAnchorLinkArea.style.opacity = '1';
            }
        }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    //desktop and mobile navbars
    for (const navBar of navBars) {
        observer.observe(navBar, config);
    }
}

function detailsElementCloseOnDropdownAnchorLinkClick() { 

    const dropDown = document.querySelector('.wp-block-acf-sticky-anchor-link-area__accordion-mobile');
    const dropdownAnchorLinks = document.querySelectorAll('.accordion__panel .wp-block-acf-sticky-anchor-link-area__link');

    if (!dropDown || !dropdownAnchorLinks.length) return;

    for (const anchorLink of dropdownAnchorLinks) {

        anchorLink.addEventListener('click', () => {
            dropDown.removeAttribute('open');
        });
    }
}

//utility function to debounce scroll events for better performance.
function debounce(func, wait) {

    let timeout;
    return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };

}

//utitily throttle function to limit how often a function can run. Useful for scroll events.
function throttle(func, limit) {

    let inThrottle;
    return function(...args) {
        if (!inThrottle) {
            func.apply(this, args);
            inThrottle = true;
            setTimeout(() => inThrottle = false, limit);
        }
    }

}

document.addEventListener('DOMContentLoaded', () => {

    stickyAnchorLinkAreaFixToNav();
    scrollPageDepthHorizontalIndicator();
    // interactWithFixedHeaderNavbar();
    observeCurrentSectionAddActiveClassToAnchorLink();
    observeFixedHeaderNavbar();
    detailsElementCloseOnDropdownAnchorLinkClick();
});